import styled from "styled-components";

interface IPopMenu {
  listName: string[] | number[];
  onClickHandlers?: Array<() => void>;
  onClick?: (value: string | number) => void | undefined;
  onClickTable?: any;
  Icon?: any;
}

export default function PopMenu({
  listName,
  onClickHandlers = [],
  Icon,
  onClick,
  onClickTable
}: IPopMenu) {
  return (
    <Container>
      {listName.map((val, index) => {
          return (
            <ButtonMenu key={index} onClick={onClickHandlers[index] || (() => onClick?.(val)) || onClickTable}>
              {Icon && <Icon size={16} weight="fill" />}
              <p>{val}</p>
            </ButtonMenu>
          );
        })
      }
    </Container>
  );
}

const Container = styled.main`
  position: absolute;
  z-index: 2;
  margin-top: 5px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 2px 2px 0px ${(props) => props.theme.colors.gray.gray_100};
  border-radius: 4px;
  padding: 5px 3px;
`;

const ButtonMenu = styled.button`
  width: 100%;
  padding: 5px 10px;
  color: ${(props) => props.theme.colors.gray.gray_800};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  font-size: 16px;
  text-align: start;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-left: 2px solid ${(props) => props.theme.colors.primary};
    padding-left: 8px;
    color: ${(props) => props.theme.colors.primary};
  }
`;
